import getWithToken from './base/get-with-token'

const getCustomerTradeWasteDataDetail = (id, type) => getWithToken(`/customer/${id}/trade-waste-meta-data?type=${type}`)()

export default getCustomerTradeWasteDataDetail